import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GritUserRoleGroup, GritUserService} from "../../../services/grit/grit.user.service";
import {FormsModule} from "@angular/forms";
import {NgForOf, NgIf} from "@angular/common";
import { ReceiverModel } from 'src/app/models/grit/grit.receiver-model';
import { DeviceModel } from 'src/app/models/grit/grit.device-model';
import { RadarModel } from 'src/app/models/grit/grit.radar-model';
import { InterferenceTestModel } from 'src/app/models/grit/grit.interference-test-model';

@Component({
  selector: 'grit-groups',
  templateUrl: './grit-groups.component.html',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    NgForOf
  ],
  styleUrls: ['./grit-groups.component.scss', '../../../app.component.scss']
})
export class GritGroupsComponent {

    @Input() hidden: boolean = false; // Default visible

    @Input() visibilityGroup : any;
    @Output() visibilityGroupChange = new EventEmitter<string>();
    get vg(){return this.visibilityGroup}
    set vg(value: string) {
      this.visibilityGroup = value;
      this.visibilityGroupChange.emit(value)
    }

    @Input() accessGroup : any;
    @Output() accessGroupChange = new EventEmitter<string>();
    get ag(){return this.accessGroup}
    set ag(value: string) {
      this.accessGroup = value;
      this.accessGroupChange.emit(value)
    }

    @Input() originatorGroup : any;
    @Output() originatorGroupChange = new EventEmitter<string>();
    get og(){return this.originatorGroup}
    set og(value: string) {
      this.originatorGroup = value;
      this.originatorGroupChange.emit(value)
    }

    constructor(protected gritUserService : GritUserService) {}

    protected readonly GritUserRoleGroup = GritUserRoleGroup;
  
  public static groupsNotNull(entity: DeviceModel | ReceiverModel | RadarModel | InterferenceTestModel): boolean {
      return entity.groupAccess != ''
        && entity.groupAccess != null
        && entity.groupOriginator != ''
        && entity.groupOriginator != null
        && entity.groupVisibility != ''
        && entity.groupVisibility != null;
    }
}
